type PrehydratedCollection = {
  id: number
  name: string
  description: string
  slug: string
  category: string
  market?: { id: number; collections_path?: string }
  image: {
    thumb: string
    medium: string
    large: string
    hero: string
  }
}

export type CollectionState = {
  data: PrehydratedCollection
  fetched: boolean
}

export type CollectionRootState = {
  collection: CollectionState
}

const initialState: CollectionState = {
  data: null,
  fetched: false,
}

/*
  During serverside rendering, data is placed in the redux store, under keys derived from reducer names.
*/
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    default:
      return state
  }
}
